<template>
    <div class="customConsult">
        <div class="consult_background">
            <div class="consult_background_img">
                <img src="../../../assets/images/foreignTrade/consultImg_01.png" alt="">
            </div>
            <div>欢迎</div>
            <div class="consult_background_text">进行服务咨询</div>
        </div>
        <div class="consult_form">
            <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm" status-icon >
                <el-row :gutter="24">
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="申请类型：" prop="sqlx">
                            <el-select v-model="ruleForm.sqlx" filterable placeholder="请选择申请类型" size="large" no-data-text=暂无数据 @change="handleChange">
                                <el-option v-for="item in applyTypeList" :key="item._id" :label="item.wmflmc" :value="item._id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">    
                        <el-form-item label="申请服务：" prop="sqfw">
                            <el-select v-model="ruleForm.sqfw" filterable :placeholder="ruleForm.sqlx?'请选择申请服务':'请先选择申请类型'" size="large" no-data-text=暂无数据>
                                <el-option v-for="item in applyServiceList" :key="item._id" :label="item.wmfwmc" :value="item._id"/>
                            </el-select>
                        </el-form-item> 
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="公司名称：" prop="gsmc">
                            <el-input v-model="ruleForm.gsmc"  placeholder="请输入公司名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="公司职务：" prop="gszw">
                            <el-input v-model="ruleForm.gszw "  placeholder="请输入公司职务" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item :label="'姓' + '　'.repeat(2) + '名：'" prop="xm">
                            <el-input v-model="ruleForm.xm"  placeholder="请输入姓名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="手机号码：" prop="lxsjh" >
                            <el-input v-model="ruleForm.lxsjh"  placeholder="请输入联系手机号" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :class="['wui-input-error-color-' + themeColor]" >     
                        <el-form-item label="咨询内容：" prop="zxnr"  >
                            <el-input v-model="ruleForm.zxnr" :autosize="{ minRows: 7, maxRows: 7 }" type="textarea" placeholder="请输入想要咨询的外贸服务内容" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <div :class="['wui-background-color-' + themeColor]" class="btn" @click="submitForm(ruleFormRef)">
                        立即提交咨询
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
export default {
    name: "secondPage",
    props:{
        themeColor: {
            type: String,
            default: 'blue'
        },
        applyTypeList:{
            type:Array,
            default:()=>([])
        }
    },
    setup(props) {
        const { proxy } = getCurrentInstance();
        const ruleFormRef=ref(null)
        const ruleForm= ref({sqfw:'',sqlx:'',gsmc:'',gszw:'',xm:'',lxsjh:'',zxnr:''})
        const rules = ref({
            sqlx: [
                { required: true, message: "请选择申请类型", trigger: "change" }
            ],
            sqfw:[
                { required: true, message: "请选择申请服务", trigger: "change" }
            ],
            xm: [
                { required: true, message: "请输入姓名", trigger: "blur" },
            ],   
            lxsjh: [
                { required: true, message: "请输入联系手机号", trigger: "blur" },
            ],
            zxnr: [
                { required: true, message: "请输入咨询内容", trigger: "blur" },
            ],
        })
        const updateTheme = () => {
            document.documentElement.style.setProperty('--el-color-primary', props.themeColor);
        }
        updateTheme()
        //提交表单
        const submitForm = async (formEl) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    addFn()
                } else {
                    console.log('error submit!', fields)
                }
            })
        }
        //保存数据
        const addFn=()=>{ 
            proxy.$request({
                url: "QPSTZX_WMFW_FWZXADD",
                method: "post",
                data:ruleForm.value
            }).then((res) => {
                if (res.data.code == "000") {
                    proxy.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    ruleForm.value={}
                    ruleFormRef.value.resetFields();
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        const applyServiceList = ref([]);
        //申请类型change
        const handleChange = (e)=>{
            if(e){
                ruleFormRef.value.resetFields('sqfw');
                applyServiceList.value = []
                getApplyService(e)
            }
        }
        //外贸服务
        const getApplyService = (id) => { 
            proxy.$request({
                url: "QPSTZX_WMFW_FWLIST",
                method: "post",
                data: {
                    ssfl:id
                },
            }).then((res) => {
                if(res.data.code=="000"){
                    applyServiceList.value =res.data.result
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        onMounted(() => {

        });
        return {
            ruleForm,
            ruleFormRef,
            applyServiceList,
            rules,
            submitForm,
            handleChange
        };
    },
};
</script>

<style lang="less" scoped>
    .customConsult {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        .consult_background {
            box-sizing: border-box;
            width: 386px;
            height: 456px;
            padding-left: 46px;
            padding-top: 65px;
            background: url(../../../assets/images/foreignTrade/boxBgImg.png) no-repeat;
            background-size: 100% 100%;
            font-size: 34px;
            line-height: 48px;
            color: #FFFFFF;
            .consult_background_img{
                width: 114px;
                height: 127px;
                margin-bottom: 44px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .consult_background_text{
                margin-top: 9px;
                font-weight: 600;
            }
        }
        .consult_form {
            box-sizing: border-box;
            flex: 1;
            background: #F9FAFC;
            padding: 28px 30px 0 30px;
            /deep/.demo-ruleForm{
                .el-form-item__content{line-height: 40px;}
                .el-input__inner{border-radius: 0;height: 34px;line-height: 40px;height: 40px;}
            }
        }
        .btn {
            width: 134px;
            height: 40px;
            background: #0754BD;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: center;
            cursor:pointer;
        }
    }
</style>